
import removeAccents from 'remove-accents';


export function getProperty(imObj, path) {
	if (Array.isArray(path)) {
		if (path.length === 0) {
			return imObj;
		} else {
			return imObj.getIn(path);
		}
	} else {
		return imObj.get(path);
	}
};

export function setProperty(imObj, path, value) {
	if (Array.isArray(path)) {
		return imObj.setIn(path, value);
	} else {
		return imObj.set(path, value);
	}
};

export function getQueryString(name) {
	var query = window.location.search.substring(1);
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=');
		if (decodeURIComponent(pair[0]) == name) {
			return decodeURIComponent(pair[1]);
		}
	}
}

export function toCamelCase(value) {
	if (!value) {
		return "";
	}
	return value.split(/_/g).filter(str => !!str).map((str, index) => {
		if (index === 0) {
			return str;
		} else {
			return str.charAt(0).toUpperCase() + str.substring(1)
		}
	}).join('');
}

export function normalize(value, separator = ' ') {
	if (value) {
		return removeAccents(value.toLowerCase()).replace(/[^a-z0-9]+/g, separator).trim();
	} else {
		return '';
	}
}